import { render, staticRenderFns } from "./OrdersEndingPage.vue?vue&type=template&id=2bbe53ae&"
import script from "./OrdersEndingPage.vue?vue&type=script&lang=ts&"
export * from "./OrdersEndingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbe53ae')) {
      api.createRecord('2bbe53ae', component.options)
    } else {
      api.reload('2bbe53ae', component.options)
    }
    module.hot.accept("./OrdersEndingPage.vue?vue&type=template&id=2bbe53ae&", function () {
      api.rerender('2bbe53ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Reports/OrdersEnding/OrdersEndingPage.vue"
export default component.exports